/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 11.1.0
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const MatchType = {
  Match: "match",
  Interpolated: "interpolated",
  Fallback: "fallback",
} as const;
export type MatchType = (typeof MatchType)[keyof typeof MatchType];

export function instanceOfMatchType(value: any): boolean {
  for (const key in MatchType) {
    if (Object.prototype.hasOwnProperty.call(MatchType, key)) {
      if (MatchType[key as keyof typeof MatchType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function MatchTypeFromJSON(json: any): MatchType {
  return MatchTypeFromJSONTyped(json, false);
}

export function MatchTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MatchType {
  return json as MatchType;
}

export function MatchTypeToJSON(value?: MatchType | null): any {
  return value as any;
}

export function MatchTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): MatchType {
  return value as MatchType;
}
